import { render, staticRenderFns } from "./TopRevenueChart.vue?vue&type=template&id=51950298&scoped=true&"
import script from "./TopRevenueChart.vue?vue&type=script&lang=js&"
export * from "./TopRevenueChart.vue?vue&type=script&lang=js&"
import style0 from "./TopRevenueChart.vue?vue&type=style&index=0&id=51950298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51950298",
  null
  
)

export default component.exports